import React, { useState, useEffect, useRef } from 'react';

const MediaUpdates = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  
  const timeoutRef = useRef(null);

  const updates = [
    {
      id: 1,
      title: "India Shifts to GPS-Backed Land Registration for Tamper-Proof...",
      description: "In a significant step towards modernizing land records, India’s central government has initiated",
      image: "https://100billion.in/client_images/2.png",
    },
    {
      id: 2,
      title: "What is EOI in Real Estate? : Meaning, Significance, and...",
      description: "Are you planning to buy an apartment in Mumbai? Picked a beautiful apartment in one of the best",
      image: "https://100billion.in/client_images/1.png",
    },
    {
      id: 3,
      title: "Mumbai RRTS Corridor Proposed with 6 Stations;...",
      description: "Plans for a new Regional Rapid Transit System (RRTS) corridor connecting Mumbai are mo",
      image: "https://100billion.in/client_images/3.png",
    },
    {
      id: 3,
      title: "Mumbai RRTS Corridor Proposed with 6 Stations;...",
      description: "Plans for a new Regional Rapid Transit System (RRTS) corridor connecting Mumbai are mo",
      image: "https://100billion.in/client_images/5.png",
    }
  ];

  const resetTimeout = () => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
  };

  useEffect(() => {
  resetTimeout();
  timeoutRef.current = setTimeout(
    () =>
      setCurrentIndex((prevIndex) => 
        // If we reach the point where the last card is visible, reset to 0
        (prevIndex + 1) % updates.length
      ),
    4000
  );

  return () => resetTimeout();
}, [currentIndex, updates.length]);

  return (
    <section className="media-section">
      <h1 className="section-title">Media and Latest Updates</h1>
      
      <div className="slider-container">
        <div 
          className="slider-track" 
          // In the JSX
        style={{ transform: `translate3d(${-currentIndex * 33.333}%, 0, 0)` }}
        >
          {updates.map((item) => (
            <div className="update-card" key={item.id}>
              <div className="card-image-wrapper">
                <img src={item.image} alt={item.title} />
              </div>
              <div className="card-content">
                <h3>{item.title}</h3>
                <p>{item.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="button-wrapper">
        <button className="explore-more-btn">Explore More</button>
      </div>
    </section>
  );
};

export default MediaUpdates;